import { AxiosError } from "axios";
import { PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import { ManutencaoDto, ListarManutencaoQuery } from "../typings";
import http from "infra/http";

export function useListarManutencoes(
  query: ListarManutencaoQuery,
  enabled: boolean = true
) {
  return useQuery<PaginateResult<ManutencaoDto>, AxiosError>(
    [`/v1/manutencao`, query, enabled],
    async () => {
      const { data } = await http.get<PaginateResult<ManutencaoDto>>(
        "/v1/manutencao",
        { params: query }
      );

      return data;
    },
    {
      enabled,
    }
  );
}
